<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <!-- ===== ستون اصلی: فرم ===== -->
      <b-col
        md="8"
        order="2"
        order-md="1"
      >
        <b-card :title="isEdit ? `ویرایش لید #${Form.Id}` : 'ثبت لید جدید'">
          <p
            v-if="!isEdit"
            class="text-muted"
          >
            وقتی مشتری از دیوار، اینستاگرام یا تماس تلفنی سراغ‌مان می‌آید، همین‌جا ثبتش کنید تا در صف پیگیری بیفتد.
          </p>

          <b-form @submit.prevent>
            <b-row>
              <b-col md="6">
                <b-form-group
                  label="نام و نام خانوادگی"
                  label-for="Name"
                >
                  <b-form-input
                    id="Name"
                    v-model="Form.Name"
                    autocomplete="off"
                    placeholder="مثلاً: رضا محمدی"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="موبایل"
                  label-for="Mobile"
                >
                  <b-form-input
                    id="Mobile"
                    v-model="Form.Mobile"
                    dir="ltr"
                    autocomplete="off"
                    placeholder="09121234567"
                    @blur="checkMobile"
                  />
                  <small
                    v-if="duplicates.length"
                    class="text-warning d-block mt-25"
                  >
                    <feather-icon
                      icon="AlertTriangleIcon"
                      size="13"
                    />
                    این شماره {{ duplicates.length }} بار دیگر ثبت شده:
                    <b-link
                      v-for="d in duplicates"
                      :key="d.Id"
                      class="mr-25"
                      :to="{ name: 'updatelead', params: { id: d.Id } }"
                    >#{{ d.Id }}</b-link>
                  </small>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="ایمیل"
                  label-for="Email"
                >
                  <b-form-input
                    id="Email"
                    v-model="Form.Email"
                    dir="ltr"
                    autocomplete="off"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="کانال ورود"
                  label-for="Channel"
                >
                  <v-select
                    v-model="Form.Channel"
                    :options="channelOptions"
                    dir="rtl"
                    taggable
                    placeholder="دیوار، تماس تلفنی، اینستاگرام…"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="منبع"
                  label-for="Source"
                >
                  <v-select
                    v-model="Form.Source"
                    :options="sourceOptions"
                    dir="rtl"
                    label="text"
                    :clearable="false"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="اولویت"
                  label-for="Priority"
                >
                  <v-select
                    v-model="Form.Priority"
                    :options="priorityOptions"
                    dir="rtl"
                    label="text"
                    :clearable="false"
                    :searchable="false"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="وضعیت"
                  label-for="Status"
                >
                  <v-select
                    v-model="Form.Status"
                    :options="statusOptions"
                    dir="rtl"
                    label="text"
                    :clearable="false"
                    :searchable="false"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="کارشناس پیگیری"
                  label-for="AssignedUserId"
                >
                  <z-user
                    v-model="Form.AssignedUserId"
                    clearable
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="مبلغ تخمینی معامله"
                  label-for="EstimatedValue"
                >
                  <b-input-group append="تومان">
                    <cleave
                      v-model="estimatedValueText"
                      class="form-control"
                      dir="ltr"
                      :raw="false"
                      :options="cleaveOptions"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="پیگیری بعدی"
                  label-for="NextFollowUpAt"
                >
                  <date-picker
                    v-model="Form.NextFollowUpAt"
                    type="datetime"
                    format="YYYY-MM-DDTHH:mm:ss"
                    display-format="jYYYY/jMM/jDD  HH:mm"
                    :clearable="true"
                    placeholder="تاریخ و ساعت تماس بعدی"
                  />
                  <div class="mt-50 quick-dates">
                    <span
                      v-for="q in quickDates"
                      :key="q.label"
                      class="chip"
                      @click="setQuickDate(q)"
                    >{{ q.label }}</span>
                  </div>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="نوع سایت درخواستی"
                  label-for="SiteType"
                >
                  <v-select
                    v-model="Form.SiteType"
                    :options="siteTypeOptions"
                    dir="rtl"
                    taggable
                    placeholder="فروشگاهی / شرکتی / شخصی"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group
                  label="از قبل سایت دارد؟"
                  label-for="HasSite"
                >
                  <v-select
                    v-model="Form.HasSite"
                    :options="hasSiteOptions"
                    dir="rtl"
                    label="text"
                    :searchable="false"
                    :reduce="x => x.value"
                    placeholder="نامشخص"
                  />
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-form-group
                  label="توضیحات / پیام مشتری"
                  label-for="Message"
                >
                  <b-form-textarea
                    id="Message"
                    v-model="Form.Message"
                    rows="4"
                    placeholder="چه چیزی خواست؟ چه بودجه‌ای دارد؟ از کجا ما را پیدا کرد؟"
                  />
                </b-form-group>
              </b-col>

              <b-col
                v-if="!isEdit"
                md="12"
              >
                <b-form-group
                  label="اولین یادداشت پیگیری (اختیاری)"
                  label-for="Note"
                >
                  <b-form-textarea
                    id="Note"
                    v-model="Form.Note"
                    rows="2"
                    placeholder="مثلاً: تماس اول، گفت هفته بعد تصمیم می‌گیرد."
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr>
              </b-col>

              <b-col class="mt-1 mb-1">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="ml-1"
                  :disabled="saving"
                  @click="save"
                >
                  <b-spinner
                    v-if="saving"
                    small
                    class="ml-25"
                  />
                  ذخیره
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  variant="outline-secondary"
                  @click="back"
                >
                  بازگشت
                </b-button>
                <b-button
                  v-if="isEdit"
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="flat-danger"
                  class="float-left"
                  @click="remove"
                >
                  حذف لید
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>

        <!-- ===== تایم‌لاین پیگیری ===== -->
        <b-card
          v-if="isEdit"
          title="پیگیری‌ها"
        >
          <b-row class="activity-form">
            <b-col md="4">
              <b-form-group
                label="نوع"
                label-for="ActivityType"
              >
                <v-select
                  v-model="activity.Type"
                  :options="activityTypeOptions"
                  dir="rtl"
                  label="text"
                  :clearable="false"
                  :searchable="false"
                  :reduce="x => x.value"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
                label="پیگیری بعدی (اختیاری)"
                label-for="ActivityFollowUp"
              >
                <date-picker
                  v-model="activity.NextFollowUpAt"
                  type="datetime"
                  format="YYYY-MM-DDTHH:mm:ss"
                  display-format="jYYYY/jMM/jDD  HH:mm"
                  :clearable="true"
                  placeholder=""
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
                label="تغییر وضعیت به (اختیاری)"
                label-for="ActivityStatus"
              >
                <v-select
                  v-model="activity.Status"
                  :options="statusOptions"
                  dir="rtl"
                  label="text"
                  :searchable="false"
                  :reduce="x => x.value"
                  placeholder="بدون تغییر"
                />
              </b-form-group>
            </b-col>

            <b-col md="12">
              <b-form-group label="شرح">
                <b-form-textarea
                  v-model="activity.Description"
                  rows="2"
                  placeholder="چه گفتید و چه شنیدید؟"
                />
              </b-form-group>
            </b-col>

            <b-col
              md="12"
              class="mb-2"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                size="sm"
                :disabled="!activity.Description || savingActivity"
                @click="addActivity"
              >
                <b-spinner
                  v-if="savingActivity"
                  small
                  class="ml-25"
                />
                ثبت پیگیری
              </b-button>
            </b-col>
          </b-row>

          <ul class="timeline">
            <li
              v-for="row in Form.Activity"
              :key="row.Id"
              class="timeline__item"
            >
              <span
                class="timeline__dot"
                :class="`bg-light-${activityMeta(row.Type).variant}`"
              >
                <feather-icon
                  :icon="activityMeta(row.Type).icon"
                  size="13"
                />
              </span>
              <div class="timeline__body">
                <div class="d-flex align-items-center justify-content-between flex-wrap">
                  <strong>{{ row.TypeTitle }}</strong>
                  <small class="text-muted">{{ row.CreatedAt | date('date-time') }}</small>
                </div>
                <p class="mb-25 timeline__text">
                  {{ row.Description }}
                </p>
                <div class="d-flex align-items-center justify-content-between">
                  <small class="text-muted">{{ row.UserName || 'سیستم' }}</small>
                  <feather-icon
                    v-if="!isSystemActivity(row.Type)"
                    icon="TrashIcon"
                    size="14"
                    class="cursor-pointer text-danger"
                    @click="removeActivity(row.Id)"
                  />
                </div>
              </div>
            </li>

            <li
              v-if="!Form.Activity || !Form.Activity.length"
              class="text-muted text-center py-2"
            >
              هنوز پیگیری‌ای ثبت نشده است.
            </li>
          </ul>
        </b-card>
      </b-col>

      <!-- ===== ستون کناری ===== -->
      <b-col
        md="4"
        order="1"
        order-md="2"
      >
        <b-card
          v-if="isEdit"
          title="اقدام سریع"
        >
          <div class="d-flex flex-column quick-actions">
            <b-button
              v-if="Form.Mobile"
              variant="outline-primary"
              :href="'tel:' + Form.Mobile"
            >
              <feather-icon
                icon="PhoneIcon"
                class="ml-50"
              />
              تماس با {{ Form.Mobile }}
            </b-button>
            <b-button
              v-if="whatsapp"
              variant="outline-success"
              target="_blank"
              :href="whatsapp"
            >
              <feather-icon
                icon="MessageCircleIcon"
                class="ml-50"
              />
              پیام واتساپ
            </b-button>
            <b-button
              v-if="Form.Email"
              variant="outline-secondary"
              :href="'mailto:' + Form.Email"
            >
              <feather-icon
                icon="MailIcon"
                class="ml-50"
              />
              ارسال ایمیل
            </b-button>
          </div>

          <hr>

          <div class="meta">
            <div class="meta__row">
              <span>وضعیت فعلی</span>
              <b-badge :variant="`light-${statusMeta(Form.Status).variant}`">
                {{ statusMeta(Form.Status).text }}
              </b-badge>
            </div>
            <div class="meta__row">
              <span>تاریخ ثبت</span>
              <strong>{{ Form.CreatedAt | date('date-time') }}</strong>
            </div>
            <div
              v-if="Form.LastActivityAt"
              class="meta__row"
            >
              <span>آخرین فعالیت</span>
              <strong>{{ Form.LastActivityAt | date('date-time') }}</strong>
            </div>
            <div class="meta__row">
              <span>ثبت‌کننده</span>
              <strong>{{ Form.CreatedByUser ? Form.CreatedByUser.Name : 'فرم سایت' }}</strong>
            </div>
            <div
              v-if="Form.DuplicateCount"
              class="meta__row"
            >
              <span>ثبت‌های تکراری</span>
              <b-badge variant="light-warning">
                {{ Form.DuplicateCount }}
              </b-badge>
            </div>
          </div>
        </b-card>

        <!-- گزارش ابزارهای رایگان سایت: کارشناس پیش از تماس می‌داند مشکل سایتِ طرف چیست -->
        <b-card
          v-if="isEdit && toolRuns.length"
          title="گزارش ابزارها"
        >
          <p class="tool-note">
            این بررسی‌ها را خودش اجرا کرده. پیش از تماس یک نگاه بیندازید — تماسِ
            «سایتت این سه ایراد را دارد» با تماسِ «سایت می‌سازیم» زمین تا آسمان فرق دارد.
          </p>

          <div
            v-for="run in toolRuns"
            :key="run.Id"
            class="tool-run"
          >
            <div class="tool-run__head">
              <feather-icon
                :icon="toolIcon(run.Tool)"
                size="15"
                class="ml-25"
              />
              <strong>{{ run.ToolTitle }}</strong>
              <b-badge
                v-if="run.Score !== null"
                :variant="`light-${scoreVariant(run.Score)}`"
                class="mr-auto"
              >
                {{ run.Score }} / ۱۰۰
              </b-badge>
            </div>

            <div
              v-if="run.Host || run.Url"
              dir="ltr"
              class="tool-run__host text-truncate"
            >
              {{ run.Host || run.Url }}
            </div>

            <div class="tool-run__tags">
              <b-badge
                v-if="run.CriticalCount"
                variant="light-danger"
              >
                {{ run.CriticalCount }} بحرانی
              </b-badge>
              <b-badge
                v-if="run.WarningCount"
                variant="light-warning"
              >
                {{ run.WarningCount }} هشدار
              </b-badge>
              <b-badge
                v-if="run.CallbackRequested"
                variant="light-primary"
              >
                خودش خواسته تماس بگیریم
              </b-badge>
              <b-badge
                v-if="run.SmsSent"
                variant="light-secondary"
              >
                گزارش پیامک شد
              </b-badge>
              <b-badge
                v-if="run.EmailSent"
                variant="light-secondary"
              >
                گزارش ایمیل شد
              </b-badge>
            </div>

            <div class="tool-run__foot">
              <span>{{ run.CreatedAt | date('date-time') }}</span>
              <a
                :href="run.ReportFullUrl"
                target="_blank"
                rel="noopener"
              >دیدن گزارش</a>
            </div>
          </div>
        </b-card>

        <b-card
          v-if="isEdit && hasTechnicalInfo"
          title="اطلاعات ورودی"
        >
          <div class="meta meta--technical">
            <div
              v-if="Form.PageUrl"
              class="meta__row"
            >
              <span>صفحه</span>
              <a
                :href="Form.PageUrl"
                target="_blank"
                dir="ltr"
                class="text-truncate"
              >{{ Form.PageUrl }}</a>
            </div>
            <div
              v-if="Form.Referrer"
              class="meta__row"
            >
              <span>ارجاع‌دهنده</span>
              <span
                dir="ltr"
                class="text-truncate"
              >{{ Form.Referrer }}</span>
            </div>
            <div
              v-if="Form.Ip"
              class="meta__row"
            >
              <span>IP</span>
              <span dir="ltr">{{ Form.Ip }}</span>
            </div>
            <div
              v-if="Form.UserAgent"
              class="meta__row"
            >
              <span>مرورگر</span>
              <span
                dir="ltr"
                class="text-truncate small"
              >{{ Form.UserAgent }}</span>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import ZUser from '@/tools/user.vue'
import {
  STATUS, PRIORITY, SOURCE, CHANNEL, ACTIVITY_TYPE, TOOL_ICON,
  statusOf, activityOf, isSystemActivity, waLink,
} from './leadOptions'

export default {
  name: 'LeadDetails',
  components: { ZUser },
  data() {
    return {
      loading: false,
      saving: false,
      savingActivity: false,
      duplicates: [],
      Form: {
        Id: null,
        Name: null,
        Mobile: null,
        Email: null,
        Message: null,
        SiteType: null,
        HasSite: null,
        Source: 'manual',
        Channel: null,
        Priority: 1,
        EstimatedValue: null,
        Status: 0,
        AssignedUserId: null,
        NextFollowUpAt: null,
        Note: null,
        Activity: [],
      },
      estimatedValueText: null,
      activity: {
        Type: 1,
        Description: null,
        NextFollowUpAt: null,
        Status: null,
      },
      statusOptions: STATUS,
      priorityOptions: PRIORITY,
      sourceOptions: SOURCE,
      channelOptions: CHANNEL,
      activityTypeOptions: ACTIVITY_TYPE,
      siteTypeOptions: ['فروشگاهی', 'شرکتی', 'شخصی', 'اپلیکیشن'],
      hasSiteOptions: [
        { value: true, text: 'بله، سایت دارد' },
        { value: false, text: 'خیر، ندارد' },
      ],
      cleaveOptions: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 0,
      },
    }
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id
    },
    whatsapp() {
      return waLink(this.Form.Mobile)
    },
    hasTechnicalInfo() {
      return !!(this.Form.PageUrl || this.Form.Referrer || this.Form.Ip || this.Form.UserAgent)
    },
    // اجراهای ابزارهای رایگان سایت (از lead/get می‌آید؛ برای لیدهای دستی خالی است)
    toolRuns() {
      return this.Form.ToolRun || []
    },
    quickDates() {
      return [
        { label: 'فردا', add: [1, 'days'] },
        { label: '۳ روز دیگر', add: [3, 'days'] },
        { label: 'هفته دیگر', add: [7, 'days'] },
      ]
    },
  },
  created() {
    if (this.isEdit) {
      this.Form.Id = Number(this.$route.params.id)
      this.get()
    }
  },
  methods: {
    isSystemActivity,
    statusMeta: statusOf,
    activityMeta: activityOf,

    toolIcon(tool) {
      return TOOL_ICON[tool] || 'ToolIcon'
    },
    // همان آستانه‌های رنگیِ خودِ ابزار در سایت (۷۵ و ۴۵) تا عدد یک معنا داشته باشد
    scoreVariant(score) {
      if (score >= 75) return 'success'
      return score >= 45 ? 'warning' : 'danger'
    },

    get() {
      this.loading = true
      this.$http.post(this.$api.lead.get, { Id: this.Form.Id })
        .then(res => {
          this.Form = { ...this.Form, ...res.data }
          this.estimatedValueText = this.Form.EstimatedValue ? String(this.Form.EstimatedValue) : null
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      const payload = {
        ...this.Form,
        EstimatedValue: this.rawNumber(this.estimatedValueText),
      }
      delete payload.Activity

      this.saving = true
      this.$http.post(this.isEdit ? this.$api.lead.update : this.$api.lead.add, payload)
        .then(res => {
          if (!this.isEdit && res.data && res.data.DuplicateCount) {
            this.$bvToast.toast(`این شماره ${res.data.DuplicateCount} بار دیگر هم ثبت شده است.`, {
              title: 'توجه', variant: 'warning', solid: false,
            })
          }
          this.back()
        })
        .finally(() => {
          this.saving = false
        })
    },
    remove() {
      this.$bvModal.msgBoxConfirm('این لید و همه‌ی پیگیری‌هایش حذف می‌شود. مطمئنید؟', {
        title: 'حذف لید',
        size: 'sm',
        okVariant: 'danger',
        okTitle: 'حذف کن',
        cancelTitle: 'انصراف',
        cancelVariant: 'outline-secondary',
        centered: true,
        modalClass: 'modal-danger modal-remove-confirm',
      })
        .then(confirm => {
          if (!confirm) return
          this.$http.post(this.$api.lead.remove, { Id: this.Form.Id })
            .then(() => this.back())
        })
    },
    checkMobile() {
      if (!this.Form.Mobile) {
        this.duplicates = []
        return
      }

      this.$http.post(this.$api.lead.checkmobile, { Mobile: this.Form.Mobile, Id: this.Form.Id })
        .then(res => {
          this.duplicates = (res.data && res.data.Items) || []
        })
    },
    addActivity() {
      this.savingActivity = true
      this.$http.post(this.$api.lead.addactivity, {
        LeadId: this.Form.Id,
        Type: this.activity.Type,
        Description: this.activity.Description,
        NextFollowUpAt: this.activity.NextFollowUpAt,
        Status: this.activity.Status,
      })
        .then(() => {
          this.activity = {
            Type: 1, Description: null, NextFollowUpAt: null, Status: null,
          }
          this.get()
        })
        .finally(() => {
          this.savingActivity = false
        })
    },
    removeActivity(id) {
      this.$http.post(this.$api.lead.removeactivity, { Id: id })
        .then(() => this.get())
    },
    setQuickDate(q) {
      this.Form.NextFollowUpAt = this.$moment().add(q.add[0], q.add[1]).hour(10).minute(0)
        .second(0)
        .format('YYYY-MM-DDTHH:mm:ss')
    },
    rawNumber(value) {
      if (value === null || value === undefined || value === '') return null
      const n = Number(String(value).replace(/[^0-9]/g, ''))
      return Number.isNaN(n) || n === 0 ? null : n
    },
    back() {
      this.$router.push({ name: 'lead' })
    },
  },
}
</script>

<style lang="scss" scoped>
.quick-actions {
  gap: .5rem;
}

.meta__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .75rem;
  padding: .45rem 0;
  border-bottom: 1px solid rgba(186, 191, 199, .25);

  &:last-child {
    border-bottom: 0;
  }

  > span:first-child {
    color: #6e6b7b;
    font-size: .85rem;
    flex: 0 0 auto;
  }

  > *:last-child {
    min-width: 0;
    text-align: left;
    direction: ltr;
  }
}

.meta--technical {
  font-size: .8rem;
}

/* کارت گزارش ابزارها */
.tool-note {
  font-size: .78rem;
  line-height: 1.9;
  color: #6e6b7b;
  margin-bottom: 1rem;
}

.tool-run {
  border: 1px solid rgba(186, 191, 199, .45);
  border-radius: .5rem;
  padding: .7rem .8rem;

  &:not(:last-child) {
    margin-bottom: .6rem;
  }
}

.tool-run__head {
  display: flex;
  align-items: center;
  gap: .3rem;
  font-size: .85rem;
}

.tool-run__host {
  font-size: .75rem;
  color: #7367f0;
  margin-top: .25rem;
}

.tool-run__tags {
  display: flex;
  flex-wrap: wrap;
  gap: .3rem;
  margin-top: .5rem;

  .badge {
    font-size: .68rem;
  }
}

.tool-run__foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: .5rem;
  margin-top: .6rem;
  font-size: .72rem;
  color: #b9b9c3;
}

.quick-dates {
  display: flex;
  gap: .35rem;
}

.chip {
  border: 1px solid rgba(186, 191, 199, .6);
  border-radius: 1rem;
  padding: .15rem .6rem;
  font-size: .75rem;
  cursor: pointer;
  user-select: none;

  &:hover {
    border-color: #7367f0;
    color: #7367f0;
  }
}

.activity-form {
  background: rgba(186, 191, 199, .08);
  border-radius: .5rem;
  padding: 1rem 0 0;
  margin: 0 0 1.5rem;
}

/* تایم‌لاین */
.timeline {
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
}

.timeline__item {
  position: relative;
  padding-right: 2.5rem;
  padding-bottom: 1.25rem;

  &:not(:last-child)::before {
    content: '';
    position: absolute;
    right: 13px;
    top: 26px;
    bottom: 0;
    width: 1px;
    background: rgba(186, 191, 199, .4);
  }
}

.timeline__dot {
  position: absolute;
  right: 0;
  top: 0;
  width: 27px;
  height: 27px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.timeline__text {
  white-space: pre-wrap;
  font-size: .88rem;
}

.dark-layout {
  .meta__row > span:first-child {
    color: #b4b7bd;
  }

  .tool-note {
    color: #b4b7bd;
  }

  .tool-run {
    border-color: rgba(180, 183, 189, .3);
  }

  .activity-form {
    background: rgba(22, 29, 49, .5);
  }

  .chip {
    border-color: rgba(180, 183, 189, .35);
  }
}
</style>
